export default function TrustBadges() {
  const badges = [
    {
      icon: 'ri-shield-check-line',
      title: 'Bezpieczne połączenie SSL',
      desc: 'Szyfrowane dane',
    },
    {
      icon: 'ri-lock-line',
      title: 'Ochrona danych',
      desc: 'Zgodność z RODO',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regularne aktualizacje',
      desc: 'Zawsze na bieżąco',
    },
    {
      icon: 'ri-verified-badge-line',
      title: 'Zweryfikowane informacje',
      desc: 'Sprawdzone przez ekspertów',
    },
  ];

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {badges.map((badge) => (
            <div key={badge.title} className="flex flex-col items-center text-center gap-3 p-5 rounded-2xl bg-background-50">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${badge.icon} text-xl text-accent-600`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{badge.title}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{badge.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}